import React, { Children, cloneElement, isValidElement } from 'react'

import * as S from './Accordion.styled'

interface HeadingProps {
  className?: string
  accordionId: string
}

const AccordionItem: React.FC<HeadingProps> = ({
  className,
  accordionId,
  children
}) => {
  const renderChildren = () => {
    return Children.map(children, (child) => {
      if (isValidElement(child)) {
        return cloneElement(child, { accordionId })
      }
    })
  }

  return (
    <S.Item id={`accordion-${accordionId}`} className={className}>
      {renderChildren()}
    </S.Item>
  )
}

export default AccordionItem
